import React, { useState, useEffect, useCallback } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleLogin from "./components/GoogleLogin";
import Layout from "./components/Layout";
import MeityDashboard from "./MeityDashboard/Dashboard";

const clientId = "930886517551-avkau17fcu6269e2avr9ptsa8vobmhco.apps.googleusercontent.com";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuthenticated") === "true"
  );

  const handleLoginSuccess = () => {
    localStorage.setItem("isAuthenticated", "true");
    setIsAuthenticated(true);
  };

  const handleLogout = useCallback(() => {
    localStorage.removeItem("isAuthenticated");
    setIsAuthenticated(false);
  }, []);

  // ----------------------------------------
  // 🔥 AUTO LOGOUT ON USER INACTIVITY (15 minutes)
  // ----------------------------------------
  useEffect(() => {
    if (!isAuthenticated) return;

    let timeout;
    const INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 minutes

    // Reset inactivity timer
    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        handleLogout();
        alert("You have been logged out due to 15 minutes of inactivity.");
      }, INACTIVITY_LIMIT);
    };

    // Activity events
    const activityEvents = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer(); // Start timer on login

    return () => {
      clearTimeout(timeout);
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [isAuthenticated, handleLogout]);

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Router>
        <Routes>
          {/* Public Route */}
          {!isAuthenticated && (
            <Route path="/" element={<GoogleLogin onLoginSuccess={handleLoginSuccess} />} />
          )}

          {/* Protected Layout */}
          {isAuthenticated && (
            <Route path="/" element={<Layout onLogout={handleLogout} />} />
          )}

          {/* Internal Dashboard */}
          <Route path="/dashboard" element={<MeityDashboard />} />

          {/* Default fallback */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
};

export default App;
